import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XDiv, XImage, XText } from "IZOX/_X";
import HTMLReactParser from "html-react-parser";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class AboutUs extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(AboutUs.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderContent(){
    let {info} = this.props;
    let {content} = info?.aboutus ?? {};
    return (
      <VStack spacing={24} width={630}>
        <XText fullWidth textAlign="[" color={ColorX.CSS("Grass")} bold fontSize={32}>
          {LocaleX.Parse({
            EN: "About Us",
            TC: "關於我們"
          })}
        </XText>
        <XText fullWidth fontSize={16}>
          {HTMLReactParser(LocaleX.Parse(content))}
        </XText>
      </VStack>
    );
  }

  renderPics(){
    let {info} = this.props;
    let {bigPic, smallPic} = info?.aboutus ?? {};
    return (
      <XDiv width={526} height={561} position="relative">
        <XDiv position="absolute" style={{ top: 0, left: 285 }}
          width={175} height={175} bgColor={ColorX.CSS("Yolk")}/>
        <XImage position="absolute" source={bigPic} noResize width={286} height={286}
          style={{ top: 88, left: 0 }}/>
        <XImage position="absolute" source={smallPic} noResize width={196} height={196}
          style={{ bottom: 146, left: 330 }}/>
        <XDiv position="absolute" style={{ bottom: 0, left: 184 }}
          width={146} height={146} bgColor={ColorX.CSS("Grass")}/>
      </XDiv>
    );
  }

  renderNormal(){
    return (
      <HStack pH={80} spacing={124} mB={80}>
        {this.renderContent()}
        {this.renderPics()}
      </HStack>
    );
  }

  renderContentM(){
    let {info} = this.props;
    let {content} = info?.aboutus ?? {};
    return (
      <VStack spacing={24} fullWidth pH={"1.5em"} >
        <XText fullWidth textAlign="[" color={ColorX.CSS("Grass")} bold fontSize={32}>
          {LocaleX.Parse({
            EN: "About Us",
            TC: "關於我們"
          })}
        </XText>
        <XText fullWidth fontSize={16}>
          {HTMLReactParser(LocaleX.Parse(content))}
        </XText>
      </VStack>
    );
  }

  renderPicsM(){
    let {info} = this.props;
    let {bigPic, smallPic} = info?.aboutus ?? {};
    return (
      <XDiv style={{transform: `scale(${Math.min(1, window.innerWidth * 0.9 / 526)})`}} mT={30}
        fitWidthToContent fitHeightToContent overflow="visible">
        <XDiv width={526} height={561} position="relative">
          <XDiv position="fixed" style={{ top: 0, left: 285 }}
            width={175} height={175} bgColor={ColorX.CSS("Yolk")}/>
          <XImage position="fixed" source={bigPic} noResize width={286} height={286}
            style={{ top: 88, left: 0 }}/>
          <XImage position="fixed" source={smallPic} noResize width={196} height={196}
            style={{ bottom: 146, left: 330 }}/>
          <XDiv position="fixed" style={{ bottom: 0, left: 184 }}
            width={146} height={146} bgColor={ColorX.CSS("Grass")}/>
        </XDiv>
      </XDiv>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth mB={20}>
        {this.renderContentM()}
        {this.renderPicsM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(AboutUs);
